import { Dictionary, Options } from '../../../models/utils';
import { InternalShipmentGroup } from '../../../models/shipment-group';

export function getCarrierAccountOptions(
  internalShipmentGroups: Dictionary<InternalShipmentGroup>,
): Options {
  const carrierAccountOptions: Options = [];
  for (const internalShipmentGroup of Object.values(internalShipmentGroups)) {
    if (!carrierAccountOptions.some(option => option.value === internalShipmentGroup.carrierAccountKey)) {
      carrierAccountOptions.push({
        label: internalShipmentGroup.carrierAccountName,
        value: internalShipmentGroup.carrierAccountKey,
      });
    }
  }
  return carrierAccountOptions;
}

export function getTagOptions(
  internalShipmentGroups: Dictionary<InternalShipmentGroup>,
): Options {
  const tagOptions: Options = [
    {
      label: 'No tag',
      value: '',
    },
  ];
  for (const internalShipmentGroup of Object.values(internalShipmentGroups)) {
    if (internalShipmentGroup.tag && !tagOptions.some(option => option.value === internalShipmentGroup.tag)) {
      tagOptions.push({
        label: internalShipmentGroup.tag,
        value: internalShipmentGroup.tag,
      });
    }
  }
  return tagOptions;
}
